export const brandVersion = '20261010-monochrome-v1';

export function brandPicture(dark = null) {
  const source = (kind, theme) => {
    const mobile = kind === 'mobile';
    const media = mobile ? '(max-width: 767px)' : '(min-width: 768px)';
    const widths = mobile ? [52,104,208] : [240,480,960];
    const srcset = widths.map(w => `/brand/legea-aplicata-logo-${kind}${theme ? '-dark' : ''}-${w}.webp?v=${brandVersion} ${w}w`).join(', ');
    const selected = theme ? (dark === null ? `${media} and (prefers-color-scheme: dark)` : dark ? media : 'not all') : media;
    return `<source type="image/webp" data-brand-theme="${theme ? 'dark' : 'light'}" data-brand-media="${media}" media="${selected}" srcset="${srcset}" sizes="${mobile ? '52px' : '(min-width: 1280px) 240px, 204px'}" width="${mobile ? 52 : 240}" height="${mobile ? 52 : 80}">`;
  };
  return '<picture>' + source('mobile',true) + source('desktop',true) + source('mobile',false) + source('desktop',false) + `<img src="/brand/legea-aplicata-logo-desktop.png?v=${brandVersion}" width="240" height="80" alt="LegeaAplicată — Legal Intelligence" decoding="async"></picture>`;
}
